var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ic-form__email" },
    [
      this.withIntrotext
        ? _c("div", { staticClass: "row my-3" }, [
            _c("div", { staticClass: "col-md-4" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-8" }, [
              _vm._v(_vm._s(_vm.$t(_vm.withIntrotext))),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("IcFormRowWrapper", {
        attrs: {
          id: "email",
          name: "email",
          label: _vm.$t("label_email"),
          aria: _vm.$t("aria_required"),
          labelWidth: 4,
          controlWidth: 8,
          showSingleError: true,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ validator }) {
              return [
                _c("IcInputEmail", {
                  attrs: {
                    id: "email",
                    agreement: _vm.data.agreement,
                    withAgreement: _vm.withAgreement,
                  },
                  on: {
                    input: function ($event) {
                      _vm.$emit("input", $event)
                      validator.$touch()
                    },
                    "agreement:update": function ($event) {
                      return _vm.$emit("update:agreement", $event)
                    },
                  },
                  model: {
                    value: _vm.data.email,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "email", $$v)
                    },
                    expression: "data.email",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _vm.withPolls
        ? _c("IcFormRowWrapper", {
            attrs: {
              id: "email",
              name: "email",
              labelWidth: 4,
              controlWidth: 8,
              showSingleError: true,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ validator }) {
                    return [
                      _c(
                        "fieldset",
                        [
                          _c("legend", [
                            _vm._v(_vm._s(_vm.$t("form_email_poll_agreement"))),
                          ]),
                          _vm._v(" "),
                          _c("IcRadioGroup", {
                            attrs: { id: "email", options: _vm.pollOptions },
                            on: {
                              input: function ($event) {
                                return _vm.$emit("update:pollAgreement", $event)
                              },
                            },
                            model: {
                              value: _vm.data.pollAgreement,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "pollAgreement", $$v)
                              },
                              expression: "data.pollAgreement",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              803059816
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }